import { toggleInSet } from './connectRepositoriesUtils';
import { SELECTION_ACTIONS } from './consts';
import { SelectionAction, SelectionState } from './types';

export const initialSelectionState: SelectionState = {
  selectedIds: new Set(),
  selectedGroupIds: new Set(),
  expandedGroups: new Set(),
  groupProjectRegistry: new Map(),
};

export const selectionReducer = (
  state: SelectionState,
  action: SelectionAction,
): SelectionState => {
  switch (action.type) {
    case SELECTION_ACTIONS.TOGGLE_PROJECT:
      return {
        ...state,
        selectedIds: toggleInSet(state.selectedIds, action.id),
      };
    case SELECTION_ACTIONS.TOGGLE_WHOLE_GROUP:
      return {
        ...state,
        selectedGroupIds: toggleInSet(state.selectedGroupIds, action.id),
      };
    case SELECTION_ACTIONS.SELECT_ALL_GROUPS:
      return { ...state, selectedGroupIds: new Set(action.ids) };
    case SELECTION_ACTIONS.SET_SELECTED_PROJECTS:
      return { ...state, selectedIds: new Set(action.ids) };
    case SELECTION_ACTIONS.SET_EXPANDED_GROUPS:
      return { ...state, expandedGroups: new Set(action.names) };

    case SELECTION_ACTIONS.REGISTER_GROUP_PROJECTS: {
      const newRegistry = new Map(state.groupProjectRegistry);
      const existing = new Set(newRegistry.get(action.groupId));

      action.ids.forEach((id) => existing.add(id));
      newRegistry.set(action.groupId, existing);

      return { ...state, groupProjectRegistry: newRegistry };
    }

    case SELECTION_ACTIONS.CLEAR_GROUP_PROJECTS: {
      const knownIds =
        state.groupProjectRegistry.get(action.groupId) ?? new Set<number>();
      const remainingIds = new Set(state.selectedIds);

      knownIds.forEach((id) => remainingIds.delete(id));

      return { ...state, selectedIds: remainingIds };
    }

    case SELECTION_ACTIONS.DESELECT_GROUP_AND_EXCLUDE_PROJECT: {
      const newSelectedGroupIds = new Set(state.selectedGroupIds);

      newSelectedGroupIds.delete(action.groupId);

      const newSelectedIds = new Set(state.selectedIds);

      action.loadedIds.forEach((id) => {
        if (id !== action.excludeId) newSelectedIds.add(id);
      });
      newSelectedIds.delete(action.excludeId);

      return {
        ...state,
        selectedGroupIds: newSelectedGroupIds,
        selectedIds: newSelectedIds,
      };
    }

    case SELECTION_ACTIONS.RESET_SELECTION:
      return {
        selectedIds: new Set(action.selectedIds),
        selectedGroupIds: new Set(),
        expandedGroups: new Set(),
        groupProjectRegistry: new Map(),
      };

    default:
      return state;
  }
};
